import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Organization } from 'src/app/modules/organization-admin/models/organization';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { OrganizationAdminService } from 'src/app/modules/organization-admin/services/organization-admin.service';
import { LeaveTypesService } from '../../services/leave-types.service';

@Component({
  selector: 'app-leave-types-create',
  templateUrl: './leave-types-create.component.html',
  styleUrls: ['./leave-types-create.component.css']
})
export class LeaveTypesCreateComponent implements OnInit {
/** USING THIS TO RESET FORM  WITH OUT SHOWING FORMVALIDAITON ERRORS**/
@ViewChild('myForm', {static: false}) myForm: NgForm;

public leaveTypeForm:FormGroup;
public organizations:Organization;

public hasRole:string = this.authservice.hasRole();
public orgId:string;

public isShowAlert:boolean= false;
public isShowOrganization:boolean = false;


constructor(private fb:FormBuilder,
  private dialog: MatDialog,
  private authservice:AuthenticationService,
  private organizationService:OrganizationAdminService,
  private leaveTypeService:LeaveTypesService

  ) { }

ngOnInit(): void {
  this.createleaveTypeForm();
  this.checkAuthenticationType();
}

checkAuthenticationType():void{
  if(this.hasRole == '1'){
    setTimeout(() => {
      this.getOrganizations();
    });
    this.isShowOrganization = true;
    this.orgId = '';
    this.leaveTypeForm.get("org_id").setValidators([Validators.required]);
    this.leaveTypeForm.get("org_id").updateValueAndValidity();
  }else{
    this.orgId = this.authservice.getOrgId();
  }
}

getOrganizations():void{
  this.organizationService.getOrganizations().subscribe(
    (res:any)=>{
      this.organizations = res.body;
    }
  );
}

createleaveTypeForm(){
  this.leaveTypeForm = this.fb.group({
    leave_type: ['',[Validators.required]],
    leave_type_desc: ['',[Validators.required]],
    org_id	: [this.orgId]
  })
}

get leaveTypeFormValidate(){
  return this.leaveTypeForm.controls;
}

leaveTypeFormSubmit(){
  if(this.leaveTypeForm.invalid){
    return;
  }

  // console.log(this.leaveTypeForm.value);

  this.leaveTypeService.createLeaveType(this.leaveTypeForm.value).subscribe(
    (res)=>{
      this.leaveTypeForm.reset();
      this.myForm.resetForm();
      this.isShowAlert= true;
      this.closeAlertMessage();
      this.createleaveTypeForm();
      this.checkAuthenticationType();
    }
  )
}

cancel():void{
  this.dialog.closeAll();
}

closeAlertMessage(){
  setTimeout(()=>{
    this.isShowAlert=false;
  },5000);
}

}
